module.exports = __webpack_public_path__ + "img/voxuy.356bc61f.svg";